/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { FullModalLayout } from '@components/molecules'
import { mono, monoShared } from '../monolith.tokens'

interface PropsType {
	title: string
	onClose: () => void
	/** 이 주문 한 건을 PDF 로 — 실패하면 던진다 */
	onDownloadPdf: () => Promise<void>
	/** 주문 내용. 포털이라 페이지 스타일이 닿지 않는다 — 페이지가 자기 css 로 감싸서 넘긴다 */
	children: React.ReactNode
}

/**
 * 계정 페이지 주문 자세히 — My Order · Wholesale Orders 공용 (2026-10-06).
 * 페이지 위에 덮이는 전체 화면 모달(FullModalLayout overlay, 760 폭, Esc 닫힘). 주소는 페이지가 정한다
 * (`/customer/order/:orderId` · `/customer/wholesale/:orderId`). 문서 맨 아래에 Download PDF.
 * 다른 주문을 열 때 PDF 상태가 남지 않게 페이지가 `key={orderId}` 로 그린다.
 */
export const MonolithOrderDetailModal = (props: PropsType): JSX.Element => {
	const { title, onClose, onDownloadPdf, children } = props
	const [pdfState, setPdfState] = React.useState<'idle' | 'working' | 'error'>('idle')

	const onPdf = async () => {
		if (pdfState === 'working') return
		setPdfState('working')
		try {
			await onDownloadPdf()
			setPdfState('idle')
		} catch (err: unknown) {
			console.error('[order detail] PDF 생성 실패', err)
			setPdfState('error')
		}
	}

	return (
		<FullModalLayout
			overlay
			size="middle"
			title={title}
			closeLabel="Close"
			onCloseClick={onClose}
		>
			{children}
			{/* 문서 맨 아래 — 이 주문 한 건을 A4 PDF 로 */}
			<View css={style} className="mnOrderDetailActions">
				<button
					type="button"
					className="mnCtaGhost"
					onClick={() => void onPdf()}
					disabled={pdfState === 'working'}
				>
					{pdfState === 'working'
						? 'Preparing'
						: pdfState === 'error'
						? 'Download failed'
						: 'Download PDF'}
				</button>
			</View>
		</FullModalLayout>
	)
}

const style = css({
	...monoShared,
	display: 'flex',
	alignItems: 'center',
	marginTop: 8,
	paddingBottom: 40,
	'.mnCtaGhost:disabled': {
		color: mono.faint,
		borderColor: mono.lineSoft,
		cursor: 'default',
	},
})
